<template>
  <div
    @click="selectChoice()"
    class="RestaurantsList__Row cursor-pointer"
    :class="{
      OutlinedItemActive: selectedChoiceId == item.id
    }"
  >
    <div class="RestaurantsList__Input">
      <label class="FormControlCheckbox -Rounded">
        <input type="radio" :checked="selectedChoiceId == item.id" />
        <span>
          <span>
            <aw-icon icon="tick" class="w-6 h-6 text-white" />
          </span>
        </span>
      </label>
    </div>

    <div class="RestaurantsList__Name space-y-1">
      <div class="text-p1 font-america-b">{{ item.name }}</div>
      <div class="mb-2">{{ item.street }}</div>
      <div class="mb-2">{{ item.city }}</div>
      <div v-html="description"></div>
    </div>

    <!-- <div class="RestaurantsList__Distance"></div> -->

    <div class="RestaurantsList__Price">0 Kč</div>
  </div>
</template>

<script>
export default {
  emits: ['on-select-choice-item'],
  props: {
    item: {
      type: Object,
      required: true
    },
    selectedChoiceId: {
      type: Number
    },
    description: {
      type: String
    }
  },
  computed: {
    // description() {
    //   return this.item.description
    //   if (this.item.description) {
    //     return this.item.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
    //   }
    //   return ''
    // }
  },
  methods: {
    selectChoice() {
      this.$emit('on-select-choice-item', this.item.id)
    }
  }
}
</script>

<style lang="scss" scoped></style>
